'use es6';

import { createContext } from 'react';

const noopFn = () => {};

export default /*#__PURE__*/createContext({
  trackEvent: noopFn,
  trackBeforeUnloadEvent: noopFn,
  trackBeforeUnloadInteraction: noopFn,
  trackInteraction: noopFn,
  trackPageview: noopFn
});